/**
 * Responsive WebP variants for the shared page-hero images. Keyed by the
 * original JPEG URL so callers can keep importing the .jpg and still get a
 * small, correctly-sized candidate instead of a full-width JPEG.
 */
import heroCarrier from "@/assets/hero-carrier.jpg";
import heroCarrier480 from "@/assets/hero-carrier-480.webp";
import heroCarrier640 from "@/assets/hero-carrier-640.webp";
import heroCarrier768 from "@/assets/hero-carrier-768.webp";
import heroCarrier1024 from "@/assets/hero-carrier-1024.webp";
import heroCarrier1376 from "@/assets/hero-carrier-1376.webp";
import enclosed from "@/assets/enclosed-carrier.jpg";
import enclosed480 from "@/assets/enclosed-carrier-480.webp";
import enclosed640 from "@/assets/enclosed-carrier-640.webp";
import enclosed768 from "@/assets/enclosed-carrier-768.webp";
import enclosed1024 from "@/assets/enclosed-carrier-1024.webp";
import enclosed1376 from "@/assets/enclosed-carrier-1376.webp";
import doorToDoor from "@/assets/door-to-door.jpg";
import doorToDoor480 from "@/assets/door-to-door-480.webp";
import doorToDoor640 from "@/assets/door-to-door-640.webp";
import doorToDoor768 from "@/assets/door-to-door-768.webp";
import doorToDoor1024 from "@/assets/door-to-door-1024.webp";
import doorToDoor1376 from "@/assets/door-to-door-1376.webp";
import hawaii from "@/assets/hawaii-port-shipping.jpg";
import hawaii480 from "@/assets/hawaii-port-shipping-480.webp";
import hawaii640 from "@/assets/hawaii-port-shipping-640.webp";
import hawaii768 from "@/assets/hawaii-port-shipping-768.webp";
import hawaii1024 from "@/assets/hawaii-port-shipping-1024.webp";
import hawaii1376 from "@/assets/hawaii-port-shipping-1376.webp";
import swfl from "@/assets/swfl-hub-carrier.jpg";
import swfl480 from "@/assets/swfl-hub-carrier-480.webp";
import swfl640 from "@/assets/swfl-hub-carrier-640.webp";
import swfl768 from "@/assets/swfl-hub-carrier-768.webp";
import swfl1024 from "@/assets/swfl-hub-carrier-1024.webp";
import swfl1376 from "@/assets/swfl-hub-carrier-1376.webp";
import openCarrier from "@/assets/open-carrier-cape-coral-pkwy.jpg";
import openCarrier480 from "@/assets/open-carrier-cape-coral-pkwy-480.webp";
import openCarrier640 from "@/assets/open-carrier-cape-coral-pkwy-640.webp";
import openCarrier768 from "@/assets/open-carrier-cape-coral-pkwy-768.webp";
import openCarrier1024 from "@/assets/open-carrier-cape-coral-pkwy-1024.webp";
import napWater from "@/assets/cape-coral-waterfront-carrier.jpg";
import napWater480 from "@/assets/cape-coral-waterfront-carrier-480.webp";
import napWater640 from "@/assets/cape-coral-waterfront-carrier-640.webp";
import napWater768 from "@/assets/cape-coral-waterfront-carrier-768.webp";
import napWater1024 from "@/assets/cape-coral-waterfront-carrier-1024.webp";
import napWater1376 from "@/assets/cape-coral-waterfront-carrier-1376.webp";
import napGolf from "@/assets/cape-coral-golf-carrier.jpg";
import napGolf480 from "@/assets/cape-coral-golf-carrier-480.webp";
import napGolf640 from "@/assets/cape-coral-golf-carrier-640.webp";
import napGolf768 from "@/assets/cape-coral-golf-carrier-768.webp";
import napGolf1024 from "@/assets/cape-coral-golf-carrier-1024.webp";
import napGolf1376 from "@/assets/cape-coral-golf-carrier-1376.webp";
import napResort from "@/assets/cape-coral-resort-carrier.jpg";
import napResort480 from "@/assets/cape-coral-resort-carrier-480.webp";
import napResort640 from "@/assets/cape-coral-resort-carrier-640.webp";
import napResort768 from "@/assets/cape-coral-resort-carrier-768.webp";
import napResort1024 from "@/assets/cape-coral-resort-carrier-1024.webp";
import napResort1376 from "@/assets/cape-coral-resort-carrier-1376.webp";
import napRes from "@/assets/cape-coral-residential-carrier.jpg";
import napRes480 from "@/assets/cape-coral-residential-carrier-480.webp";
import napRes640 from "@/assets/cape-coral-residential-carrier-640.webp";
import napRes768 from "@/assets/cape-coral-residential-carrier-768.webp";
import napRes1024 from "@/assets/cape-coral-residential-carrier-1024.webp";
import napRes1376 from "@/assets/cape-coral-residential-carrier-1376.webp";
import truckGuide from "@/assets/truck-shipping-guide.jpg";
import truckGuide480 from "@/assets/truck-shipping-guide-480.webp";
import truckGuide640 from "@/assets/truck-shipping-guide-640.webp";
import truckGuide768 from "@/assets/truck-shipping-guide-768.webp";
import truckGuide1024 from "@/assets/truck-shipping-guide-1024.webp";
import truckGuide1376 from "@/assets/truck-shipping-guide-1376.webp";

export const HERO_SIZES = "100vw";

/** Half-width feature images (two-column on desktop). */
export const FEATURE_SIZES = "(min-width: 1024px) 50vw, 100vw";

const MAP: Record<string, string> = {
  [heroCarrier]: `${heroCarrier480} 480w, ${heroCarrier640} 640w, ${heroCarrier768} 768w, ${heroCarrier1024} 1024w, ${heroCarrier1376} 1376w`,
  [enclosed]: `${enclosed480} 480w, ${enclosed640} 640w, ${enclosed768} 768w, ${enclosed1024} 1024w, ${enclosed1376} 1376w`,
  [doorToDoor]: `${doorToDoor480} 480w, ${doorToDoor640} 640w, ${doorToDoor768} 768w, ${doorToDoor1024} 1024w, ${doorToDoor1376} 1376w`,
  [hawaii]: `${hawaii480} 480w, ${hawaii640} 640w, ${hawaii768} 768w, ${hawaii1024} 1024w, ${hawaii1376} 1376w`,
  [swfl]: `${swfl480} 480w, ${swfl640} 640w, ${swfl768} 768w, ${swfl1024} 1024w, ${swfl1376} 1376w`,
  [openCarrier]: `${openCarrier480} 480w, ${openCarrier640} 640w, ${openCarrier768} 768w, ${openCarrier1024} 1024w`,
  [napWater]: `${napWater480} 480w, ${napWater640} 640w, ${napWater768} 768w, ${napWater1024} 1024w, ${napWater1376} 1376w`,
  [napGolf]: `${napGolf480} 480w, ${napGolf640} 640w, ${napGolf768} 768w, ${napGolf1024} 1024w, ${napGolf1376} 1376w`,
  [napResort]: `${napResort480} 480w, ${napResort640} 640w, ${napResort768} 768w, ${napResort1024} 1024w, ${napResort1376} 1376w`,
  [napRes]: `${napRes480} 480w, ${napRes640} 640w, ${napRes768} 768w, ${napRes1024} 1024w, ${napRes1376} 1376w`,
  [truckGuide]: `${truckGuide480} 480w, ${truckGuide640} 640w, ${truckGuide768} 768w, ${truckGuide1024} 1024w, ${truckGuide1376} 1376w`,
};

/** Smallest candidate, used as the default `src` so slow phones fetch the least. */
const SMALL: Record<string, string> = {
  [heroCarrier]: heroCarrier480,
  [enclosed]: enclosed480,
  [doorToDoor]: doorToDoor480,
  [hawaii]: hawaii480,
  [swfl]: swfl480,
  [openCarrier]: openCarrier480,
  [napWater]: napWater480,
  [napGolf]: napGolf480,
  [napResort]: napResort480,
  [napRes]: napRes480,
  [truckGuide]: truckGuide480,
};

export function heroSrcSet(src: string): string | undefined {
  return MAP[src];
}

export function heroSmallSrc(src: string): string {
  return SMALL[src] ?? src;
}
